import { useSearchParams } from "react-router-dom";
import { KeywordBankContentV2, Segment } from "@/components/keyword-bank/KeywordBankContentV2";
import { useProductDetailContext } from "@/contexts/ProductDetailContext";

const SEGMENT_VALUES: Segment[] = [Segment.ALL_KEYWORDS, Segment.MASTER_LIST];
const DEFAULT_SEGMENT = Segment.ALL_KEYWORDS;

export default function ProductKeywordsPage() {
  const { productDetail } = useProductDetailContext();
  const [searchParams] = useSearchParams();

  // AUT-256: this is the only place that renders KeywordBankContentV2 today --
  // DeveloperHandoff.tsx and AddThemeModal.tsx don't render it at all (the first only
  // names it in a documentation table, the second only mentions it in a comment) -- so
  // the segment lives in the URL unconditionally here. Unknown or absent falls back to
  // All Keywords. There is no change handler: KeywordBankContentV2's segment links
  // navigate on their own, and this re-derives `segment` from the resulting URL on the
  // next render -- a second, redundant setSearchParams push here double-pushed history
  // (AUT-256 fix round).
  const requested = searchParams.get("segment");
  const segment = SEGMENT_VALUES.includes(requested as Segment) ? (requested as Segment) : DEFAULT_SEGMENT;

  return (
    <div className="p-6 [&_table]:border-0 [&_.v2-table-section]:rounded-none [&_.v2-table-section]:border-x-0 [&_.v2-table-section]:border-b-0">
      <KeywordBankContentV2
        productId={productDetail.id}
        heroAsin={productDetail.asin}
        segment={segment}
      />
    </div>
  );
}
